// import React, { useState, useEffect } from "react";
// import { Box, Typography, Switch, FormControlLabel, CircularProgress, Button } from "@mui/material";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../AuthContext";

// const API_URL = process.env.REACT_APP_API_URL;

// const ExpertAvailability = () => {
//   const { userId } = useAuth(); // this must match Expert.user_id
//   const expertId = userId;

//   const [available, setAvailable] = useState(false);
//   const [approved, setApproved] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchExpert = async () => {
//       if (!expertId) {
//         setLoading(false);
//         setError("No expert ID found. Are you logged in?");
//         return;
//       }

//       setLoading(true);
//       setError("");

//       try {
//         const { data } = await axios.post(`${API_URL}/experts/detail/`, {
//           user_id: expertId,
//         });
//         console.log("DATA FROM BACKEND:", data);
//         setApproved(data.status === "approved");
//         setAvailable(data.available);
//       } catch (err) {
//         console.error("Failed to fetch expert:", err);
//         setError(
//           err.response?.data?.error || "Failed to fetch expert data. Please try again."
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchExpert();
//   }, [expertId]);

//   const handleToggle = async (event) => {
//     const newValue = event.target.checked;
//     setAvailable(newValue); // optimistic update

//     try {
//       await axios.post(`${API_URL}/experts/update-availability/`, {
//         user_id: expertId,
//         available: newValue,
//       });
//     } catch (err) {
//       console.error("Failed to update availability:", err);
//       setAvailable(!newValue); // revert toggle if update fails
//       setError(
//         err.response?.data?.error || "Failed to update availability."
//       );
//     }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 1 }}>
//         <CircularProgress size={20} />
//         <Typography>Loading expert data...</Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ mt: 3 }}>
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   if (!approved) {
//     return (
//       <Box sx={{ mt: 3 }}>
//         <Typography color="warning.main">
//           Your profile is not approved yet. Availability toggle is not available.
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ mt: 3 }}>
//       <FormControlLabel
//         control={
//           <Switch
//             checked={available}
//             onChange={handleToggle}
//             color="primary"
//           />
//         }
//         label={available ? "Profile Visible" : "Profile Hidden"}
//       />
//        <Typography
//     variant="body2"
//     color="text.secondary"
//     sx={{ mt: 1, maxWidth: 400 }}
//   >
//     Turning this on will make your profile visible to users. Only your profile
//     picture, name, designation, and about section will be visible. No contact
//     information or personal details will be displayed.
//   </Typography>

//   <Button
//     variant="contained"
//     color="primary"
//     sx={{ mt: 2, borderRadius: 3 }}
//     onClick={() => navigate(`/expert-profile?expert_id=${expertId}`)}
//   >
//     View My Profile
//   </Button>
//     </Box>
//   );
// };

// export default ExpertAvailability;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Switch,
//   FormControlLabel,
//   CircularProgress,
//   Button
// } from "@mui/material";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../AuthContext";

// const API_URL = process.env.REACT_APP_API_URL;

// const ExpertAvailability = () => {
//   const { userId, loggedIn } = useAuth();
//   const navigate = useNavigate();

//   const [available, setAvailable] = useState(false);
//   const [approved, setApproved] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     // 🚨 WAIT until auth is resolved
//     if (loggedIn === null) return;

//     // 🚨 If not logged in → real error
//     if (!userId) {
//       setError("User not logged in.");
//       setLoading(false);
//       return;
//     }

//     const fetchExpert = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const { data } = await axios.post(
//           `${API_URL}/experts/detail/`,
//           {
//             user_id: userId,
//           }
//         );

//         console.log("DATA FROM BACKEND:", data);

//         setApproved(data.status === "approved");

//         // ✅ FORCE BOOLEAN (important)
//         setAvailable(Boolean(data.available));

//       } catch (err) {
//         console.error("Failed to fetch expert:", err);
//         setError(
//           err.response?.data?.error ||
//           "Failed to fetch expert data."
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchExpert();
//   }, [userId, loggedIn]);

//   const handleToggle = async (event) => {
//     const newValue = event.target.checked;

//     // optimistic update
//     setAvailable(newValue);

//     try {
//       await axios.post(`${API_URL}/experts/update-availability/`, {
//         user_id: userId,
//         available: newValue, // ✅ always true/false
//       });
//     } catch (err) {
//       console.error("Failed to update availability:", err);

//       // revert if failed
//       setAvailable((prev) => !prev);

//       setError(
//         err.response?.data?.error ||
//         "Failed to update availability."
//       );
//     }
//   };

//   // 🔄 WAITING FOR AUTH OR API
//   if (loading || loggedIn === null) {
//     return (
//       <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 1 }}>
//         <CircularProgress size={20} />
//         <Typography>Loading expert data...</Typography>
//       </Box>
//     );
//   }

//   // ❌ ERROR STATE
//   if (error) {
//     return (
//       <Box sx={{ mt: 3 }}>
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   // 🚫 NOT APPROVED
//   if (!approved) {
//     return (
//       <Box sx={{ mt: 3 }}>
//         <Typography color="warning.main">
//           Your profile is not approved yet. Availability toggle is not available.
//         </Typography>
//       </Box>
//     );
//   }

//   // ✅ MAIN UI
//   return (
//     <Box sx={{ mt: 3 }}>
//       <FormControlLabel
//         control={
//           <Switch
//             checked={available}
//             onChange={handleToggle}
//             color="primary"
//           />
//         }
//         label={available ? "Profile Visible" : "Profile Hidden"}
//       />

//       <Typography
//         variant="body2"
//         color="text.secondary"
//         sx={{ mt: 1, maxWidth: 400 }}
//       >
//         Turning this on will make your profile visible to users. Only your profile
//         picture, name, designation, and about section will be visible.
//       </Typography>

//       <Button
//         variant="contained"
//         sx={{ mt: 2, borderRadius: 3 }}
//         onClick={() =>
//           navigate(`/expert-profile?expert_id=${userId}`)
//         }
//       >
//         View My Profile
//       </Button>
//     </Box>
//   );
// };

// export default ExpertAvailability;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  CircularProgress,
  Button,
  TextField,
  MenuItem,
  Stack,
  Chip
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const ExpertAvailability = ({ consultationFee, setConsultationFee }) => {
  const { userId, loggedIn } = useAuth();
  const navigate = useNavigate();

  const [available, setAvailable] = useState(false);
  const [approved, setApproved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
 

  // 🔹 NEW STATES FOR SLOTS
  const [slots, setSlots] = useState([]);
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  // ================= FETCH EXPERT =================
  useEffect(() => {
    if (loggedIn === null) return;

    if (!userId) {
      setError("User not logged in.");
      setLoading(false);
      return;
    }

    const fetchExpert = async () => {
      try {
        const { data } = await axios.post(`${API_URL}/experts/detail/`, {
          user_id: userId,
        });

        setApproved(data.status === "approved");
        setAvailable(Boolean(data.available));
        // setConsultationFee(data.consultation_fee || 500);
      } catch (err) {
        setError("Failed to fetch expert data.");
      } finally {
        setLoading(false);
      }
    };

    fetchExpert();
  }, [userId, loggedIn]);

  // ================= TOGGLE =================
  const handleToggle = async (event) => {
    const newValue = event.target.checked;
    setAvailable(newValue);

    try {
      await axios.post(`${API_URL}/experts/update-availability/`, {
        user_id: userId,
        available: newValue,
      });
    } catch {
      setAvailable((prev) => !prev);
    }
  };

  // ================= ADD SLOT =================
  const handleAddSlot = () => {
    if (!startTime) return;

    const newSlot = {
      date,
      start_time: startTime,
     
    };

    setSlots((prev) => [...prev, newSlot]);
    setStartTime("");
    // setEndTime("");
  };

  // ================= REMOVE SLOT =================
  const handleRemoveSlot = (index) => {
    setSlots((prev) => prev.filter((_, i) => i !== index));
  };

  // ================= SAVE SLOTS =================
  const handleSaveSlots = async () => {
    try {
      await axios.post(`${API_URL}/experts/save-slots/`, {
        user_id: userId,
        slots,
      });

      alert("Slots saved successfully!");
    } catch {
      alert("Failed to save slots");
    }
  };

  // ================= UI STATES =================
  if (loading || loggedIn === null) {
    return (
      <Box sx={{ mt: 3 }}>
        <CircularProgress size={20} />
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (!approved) {
    return (
      <Typography color="warning.main">
        Profile not approved yet.
      </Typography>
    );
  }

  // ================= MAIN UI =================
  return (
    <Box sx={{ mt: 3 }}>
      {/* 🔹 AVAILABILITY TOGGLE */}
      <FormControlLabel
        control={
          <Switch
            checked={available}
            onChange={handleToggle}
          />
        }
        label={available ? "Profile Visible" : "Profile Hidden"}
      />
      
      <Box sx={{ mt: 3 }}>
  <Typography variant="h6">Consultation Pricing</Typography>


  <TextField
  label="1 Hour Consultation Fee (₹)"
  type="number"
  value={consultationFee}
  onChange={(e) => {
    const val = e.target.value;

    // allow empty (for typing)
    if (val === "") {
      setConsultationFee("");
      return;
    }

    // allow only numbers
    if (!/^\d+$/.test(val)) return;

    setConsultationFee(val);
  }}
  onBlur={() => {
    let val = Number(consultationFee);

    if (!val || val < 300) val = 300;
    if (val > 3000) val = 3000;

    setConsultationFee(val);
  }}
  inputProps={{
    min: 300,
    max: 3000
  }}
  helperText="Allowed range: ₹300 – ₹3000"
  fullWidth
  sx={{ mt: 2 }}
/>

  <Typography variant="body2" sx={{ mt: 1, color: "#aaa" }}>
    30min: ₹{consultationFee / 2} | 1hr: ₹{consultationFee} | 1.5hr: ₹{consultationFee * 1.5} | 2hr: ₹{consultationFee * 2}
  </Typography>
</Box>

      {/* 🔹 TIME SLOT SECTION */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Set Available Time Slots</Typography>

        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <TextField
  type="date"
  label="Date"
  value={date}
  onChange={(e) => setDate(e.target.value)}
  size="small"
  InputLabelProps={{ shrink: true }}
/>

          <TextField
            type="time"
            label="Start"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
          />

          {/* <TextField
            type="time"
            label="End"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
          /> */}

          <Button variant="contained" onClick={handleAddSlot}>
            Add
          </Button>
        </Stack>

        {/* 🔹 SLOT LIST */}
        <Box sx={{ mt: 2 }}>
          {slots.map((slot, index) => (
            <Chip
              key={index}
              label={`${slot.date} ${slot.start_time}`}
              onDelete={() => handleRemoveSlot(index)}
              sx={{ mr: 1, mb: 1 }}
            />
          ))}
        </Box>

        {/* 🔹 SAVE BUTTON */}
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleSaveSlots}
        >
          Save Slots
        </Button>
      </Box>

      {/* 🔹 PROFILE BUTTON */}
      <Button
        variant="outlined"
        sx={{ mt: 3 }}
        onClick={() =>
          navigate(`/expert-profile?expert_id=${userId}`)
        }
      >
        View My Profile
      </Button>
    </Box>
  );
};

export default ExpertAvailability;